import * as fileUtils from 'FileManagerCore/utils/file';
export const getThumbnailUrl = fileUtils.getImageSrc;
export const getHasThumbnail = fileUtils.getHasThumbnail;